




















import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "AvatarBorderAnimation",
  props: {
    avatarSize: { type: Number, required: true },
    borderWidth: { type: Number, required: true },
  },
});
